module.exports = __webpack_public_path__ + "img/12.0351eb5e.jpg";